import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell, TabbedPage, type TabbedPageTab } from "../../components/layout";
import AuditLogPage from "../audit-log/ui";
import BusinessErrorsPage from "../business-errors/ui";

/** Operational logs: who did what (audit) and what failed (business errors). */
const Logs = () => {
  const { t } = useTranslation();
  const tabs = useMemo<TabbedPageTab[]>(
    () => [
      {
        key: "audit",
        label: t("superAdmin.tabs.audit"),
        icon: <HistoryOutlinedIcon fontSize="small" />,
        render: () => <AuditLogPage />,
      },
      {
        key: "errors",
        label: t("superAdmin.tabs.errors"),
        icon: <BugReportOutlinedIcon fontSize="small" />,
        render: () => <BusinessErrorsPage />,
      },
    ],
    [t]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <TabbedPage title={t("nav.logs")} tabs={tabs} />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default Logs;
